import React from 'react';
import { BookOpenIcon } from 'lucide-react';
import { tomos } from '../data/content';
import { Reveal } from './Reveal';
export function Tomos() {
  return <section className="bg-mint-50 py-20 sm:py-28" id="contenido" aria-labelledby="tomos-title" data-id="element-217" data-mp="139l7ssizc22x">
      <div className="mx-auto max-w-6xl px-6" data-id="element-218" data-mp="1h573fijpxk4b">
        <Reveal className="max-w-3xl" data-id="element-219" data-mp="1cc47j3rgxyky">
          <p className="inline-flex items-center gap-2 rounded-full bg-white px-3.5 py-1.5 text-sm font-medium text-mint-700 ring-1 ring-inset ring-mint-200" data-id="element-220" data-mp="1cb2vavypv61n">
            <BookOpenIcon className="h-4 w-4" aria-hidden="true" data-id="element-221" data-mp="1m2yvcckd568i" />
            Lo que recibís
          </p>
          <h2 id="tomos-title" className="mt-5 font-display text-3xl leading-tight text-ink sm:text-4xl lg:text-[2.75rem]" data-id="element-222" data-mp="200x7dbb7oqku">
            6 tomos principales: tu camino de 15 días
          </h2>
          <p className="mt-4 text-lg text-ink-soft" data-id="element-223" data-mp="5n5r3sydn8gf">
            Organizados por progresión. Empezás por el tomo 1 y avanzás sin
            decidir nada por tu cuenta.
          </p>
        </Reveal>

        <ol className="mt-12 grid gap-px overflow-hidden rounded-3xl bg-mint-200 sm:grid-cols-2 lg:grid-cols-3" data-id="element-224" data-mp="34rhs8rx6a4yt">
          {tomos.map((tomo, index) => <li key={tomo.number} className="flex" data-id="element-225" data-mp="39q2usxzwd0qf" data-mpi={index}>
              <Reveal delay={index * 0.04} className="flex h-full w-full flex-col bg-white p-7" data-id="element-226" data-mp="3eomdmpj71wek">
                <span className="font-display text-4xl leading-none text-mint-300" data-id="element-227" data-mp="3jfw1plp3groc">
                  {String(tomo.number).padStart(2, '0')}
                </span>
                <h3 className="mt-5 font-display text-xl text-ink" data-id="element-228" data-mp="3oh1u1ieuecxc">
                  {tomo.title}
                </h3>
                {tomo.subtitle ? <p className="mt-1 text-sm font-medium uppercase tracking-wide text-mint-600" data-id="element-229" data-mp="19q4xqtze96y">
                    {tomo.subtitle}
                  </p> : null}
                <p className="mt-3 text-[15px] leading-relaxed text-ink-soft" data-id="element-230" data-mp="66q9tyf3h5wh">
                  {tomo.description}
                </p>
              </Reveal>
            </li>)}
        </ol>
      </div>
    </section>;
}